// extracted by css-extract-rspack-plugin
export default {"container":"container-cjEE_y"};